import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {

  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem("cartItems");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  // ✅ FIXED ADD TO CART (USING _id)
  const addToCart = (product) => {
    setCartItems((prev) => {
      const existing = prev.find(
        (item) => item._id === product._id   // 🔥 FIX
      );

      if (existing) {
        return prev.map((item) =>
          item._id === product._id           // 🔥 FIX
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }

      return [
        ...prev,
        {
          ...product,
          quantity: 1,
          specification: product.specification || "",
          file: null,
        },
      ];
    });
  };

  // ✅ REMOVE / DECREASE QUANTITY
  const removeFromCart = (index) => {
    setCartItems((prev) => {
      const updated = [...prev];

      if (updated[index].quantity > 1) {
        updated[index].quantity -= 1;
      } else {
        updated.splice(index, 1);
      }

      return updated;
    });
  };

  // ✅ UPDATE SPECIFICATION
  const updateDescription = (index, value) => {
    setCartItems((prev) => {
      const updated = [...prev];
      updated[index].specification = value;
      return updated;
    });
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateDescription,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};